import { Component, Input, OnInit } from '@angular/core';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { SubscriptionError } from 'src/app/shared/enum/SubscriptionError';

@Component({
    selector: 'app-subscription-details',
    templateUrl: './subscription-details.component.html',
    styleUrls: ['./subscription-details.component.scss']
})
export class SubscriptionDetailsComponent implements OnInit {

  @Input() sidenavExpanded: boolean;
  subscriptionError = SubscriptionError;

  status: number;
  errorCode = "";
  errorMessage = "";

  constructor(private request: DoHttpService) { }

  ngOnInit(): void {
      this.getSubScription();
  }

  getSubScription() {
      this.request.get(`${this.request.clientBaseUrl}/subscription`).subscribe(result => {
          this.setMessage(result);
      });
  }

  setMessage(sub: any) {
      this.status = sub.status;
      let date = new Date();
      if(sub && sub?.endDate){
          date = new Date(sub?.endDate);
      }
      switch (sub.status) {
      case this.subscriptionError.Valid: {
          this.errorCode = "Subscription Valid";
          this.errorMessage = `Your organisation subscription is valid till : ${date}`;
          break;
      }
      case this.subscriptionError.Expired: {
          this.errorCode = "Subscription Expired";
          this.errorMessage = `Your organisation subscription expired on : ${date}`;
          break;
      }
      case this.subscriptionError.Invalid: {
          this.errorCode = "Subscription Invalid";
          this.errorMessage = `Your organisation subscription is invalid`;
          break;
      }
      case this.subscriptionError.NoSubscription: {
          this.errorCode = "Free version";
          this.errorMessage = `You are using the free version of Drawout App.`;
          break;
      }
      case this.subscriptionError.NoSubscription: {
          this.errorCode = "Subscription Error";
          this.errorMessage = "There is an issue with your subcription please contact support";
          break;
      }
      default: {
          this.errorCode = "Error";
          this.errorMessage = "There is an issue with your subcription please contact support";
          break;
      }
      }
  }

}
